import {
    CONFIRMED_GET_OWNERSHIP_TYPES
} from '../actions/OwnershipType/OwnershipTypeTypes';
const initialState = {
    ownershipTypes: [],
    loading: false,
};
function OwnershipTypesReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'OWNERSHIP_TYPES_LOADING':
            return {
                ...state,
                loading: true,
            };
        case CONFIRMED_GET_OWNERSHIP_TYPES:
            return {
                ...state,
                ownershipTypes: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {OwnershipTypesReducer};